/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { compareNaturalDependencies } from './dependenciesCompareNatural.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSetSize } from '../../factoriesAny.js';
export var setSizeDependencies = {
  compareNaturalDependencies: compareNaturalDependencies,
  typedDependencies: typedDependencies,
  createSetSize: createSetSize
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSetSize.generated.js
// module id = 1514
// module chunks = 0